import React, { useCallback, useEffect, useMemo, useRef} from 'react';

import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import './FilterDropdown.scss'
import { useDispatch, useSelector } from 'react-redux';
import { setProduct } from '../../redux/actions/product';

interface IFilterDropdown{
    placeholder:string
    filterKey:string
    list:string[]
    onValueSelected: (key:string|null,value:string|null, clearAll?:boolean)=>void
}

export const FilterDropdown = (props:IFilterDropdown)=>{

    // registerLicense('Mgo+DSMBaFt+QHJqUE1hXk5Hd0BLVGpAblJ3T2ZQdVt5ZDU7a15RRnVfR1xqSXlXcEZkUXpYeA==;Mgo+DSMBPh8sVXJ1S0R+WVpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF5jTH9adkJnX3xZeHNUTg==;ORg4AjUWIQA/Gnt2VFhiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXtSf0VkXXldd3xdQ2g=;MjExNTY2MUAzMjMxMmUzMjJlMzVKR3pvd2pDN1VPbTlEdE81WHVOeE5WaGFtZ25RN3hSTTFBVlZqdHoxZkRnPQ==;MjExNTY2MkAzMjMxMmUzMjJlMzVYbXBackFZaE1tSnBUZEYyOTNDM3JFMVhGbldWSDliTlFLaHlFcDBBczJZPQ==;NRAiBiAaIQQuGjN/V0d+Xk9BfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5Wd0xjXntYc3NcQGZU;MjExNTY2NEAzMjMxMmUzMjJlMzVvTE93a1dFK2tRWmJ5aU5naEh5bDY1Qk5EUW5zVjh0YWt2Ni8zekpiVkpFPQ==;MjExNTY2NUAzMjMxMmUzMjJlMzVEZXhMNk9NVE14ekxMZjF2ZU1JR1ZmendlbnNHamJCUnVKUG1RYzhWUHZRPQ==;Mgo+DSMBMAY9C3t2VFhiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXtSf0VkXXldeHRRRWg=;MjExNTY2N0AzMjMxMmUzMjJlMzVCbUZKeVJ4R2VlMTkvekg0UWpJS1M0MERLaVJXa3hZU1F6c0NyY0gwZ0NrPQ==;MjExNTY2OEAzMjMxMmUzMjJlMzVWVEV3Z2xVMUZ1TTBjR29oSWlSNFBoSzNNS21BZzhIbDZVL0ZjVmhmd1A4PQ==;MjExNTY2OUAzMjMxMmUzMjJlMzVvTE93a1dFK2tRWmJ5aU5naEh5bDY1Qk5EUW5zVjh0YWt2Ni8zekpiVkpFPQ==');

    const dispatch = useDispatch();

    const options:any[] = props.list||[];//useSelector((state:any) => state.products)

    const listRef = useRef(undefined as any)

    const list = useMemo(()=>{
        return options.map((option:any)=>({
            text: option,
            value: option
        }))
    },[options])

    const selectCategory = useCallback(()=>{
        if(listRef.current){
            const option = options.filter((option:any)=>option===listRef.current?.value)
            if(option && option.length){
                props.onValueSelected(props.filterKey, option[0]);
            }else{
                props.onValueSelected(props.filterKey, null);
            }
            
        }
    },[options, props.onValueSelected, props.filterKey])

    return <DropDownListComponent showClearButton placeholder={props.placeholder} ref={listRef} onChange={selectCategory} dataSource={list}/>
}